import { FormFieldGroup, FormLabel, FormLabelDescription, FormSelect, FormTextarea } from '$components'
import { Input } from './index'
import { Currency } from '$api-client/types.gen'

export function EditServiceInfoContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Description}>
          Description
        </FormLabel>

        <FormLabelDescription>
          Describe what&apos;s included in this service. (This will be visible to your clients).
        </FormLabelDescription>

        <FormTextarea
          name={Input.Description}
          placeholder="Enter service description..."
          rows={4}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Notes}>
          Internal Notes
        </FormLabel>

        <FormLabelDescription>
          Add any internal notes about this service (only visible to you and your team).
        </FormLabelDescription>

        <FormTextarea
          name={Input.Notes}
          placeholder="Enter internal notes..."
          rows={4}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Currency}>
          Currency
        </FormLabel>

        <FormLabelDescription>
          Choose what currency the cost of this service is in.
        </FormLabelDescription>

        <FormSelect
          name={Input.Currency}
          placeholder="Select currency..."
          options={Object.values(Currency).map((currency) => ({
            id: currency,
            value: currency,
          }))}
        />
      </FormFieldGroup>
    </div>
  )
}
